import(/* webpackMode: "eager" */ "/app/src/components/loading.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/PackagesPage.jsx");
